import * as types from './types';
import LocalStorage from '../../utils/localStorage';

export const changeLocale = locale => dispatch => {
    LocalStorage.setItem('lang', locale);
    dispatch({
        type: types.CHANGE_LOCALE,
        payload: locale,
    });
};

export const changeTheme = theme => ({
    type: types.CHANGE_THEME,
    payload: theme,
});

export const changeTranslationMode = payload => ({
    type: types.CHANGE_TRANSLATION_MODE,
    payload,
});
